import { AlertTriangleIcon } from 'lucide-react-native';

import { HStack } from '@/components/ui/hstack';
import { Icon } from '@/components/ui/icon';
import { Link, LinkText } from '@/components/ui/link';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';

export type NpiConflictInfoBoxProps = {
  maskedEmail: string;
  onSignIn: () => void;
  onContactSupport: () => void;
};

/**
 * Inline warning box component for displaying NPI conflict information.
 * Shows below the NPI input field when an NPI is already associated with an existing account.
 */
export function NpiConflictInfoBox({
  maskedEmail,
  onSignIn,
  onContactSupport,
}: NpiConflictInfoBoxProps) {
  return (
    <VStack className="mt-3 w-full self-stretch rounded-md bg-background-warning px-4 py-4">
      <HStack className="w-full items-start gap-2">
        <Icon
          as={AlertTriangleIcon}
          className="mt-0.5 h-[18px] w-[18px] flex-shrink-0 text-warning-800"
        />

        <VStack className="min-w-0 flex-1 gap-1.5">
          <Text size="sm" className="w-full font-semibold text-typography-900">
            Do you already have an account linked to this NPI?
          </Text>

          <VStack className="w-full gap-0">
            <Text size="xs" className="w-full text-typography-700">
              We found an existing account using {maskedEmail}. Sign in once to link your account.
              After linking, you'll be able to log in with Google or email.
            </Text>

            <HStack className="mt-2 flex-wrap items-center">
              <Link onPress={onSignIn}>
                <LinkText size="xs" className="text-warning-800 underline">
                  Sign in
                </LinkText>
              </Link>
              <Text size="xs" className="mx-1 text-typography-700">
                or
              </Text>
              <Link onPress={onContactSupport}>
                <LinkText size="xs" className="text-warning-800 underline">
                  Contact Support
                </LinkText>
              </Link>
            </HStack>
          </VStack>
        </VStack>
      </HStack>
    </VStack>
  );
}
